jQuery(document).ready(function () {
    quizStart();
    startQuiz();
    next();
    resultButton();
    responseOutput();
    initOptOut();
    initBrowserCheck();
});

function resultButton() {
    let button = jQuery('.result-button');

    button.on('click', function() {
        window.open('https://ausbildung.sparkasse-bielefeld.de/');
    })
}
function quizStart() {
    let button = jQuery('.quiz-start');
    element = jQuery('.quiz');

    button.on('click', function () {
        if (element.hasClass('active')) {
            element.removeClass('active');
            element.addClass('hide');
        } else {
            element.addClass('active');
            element.removeClass('hide');
        }

    })
}

// Array with Questions
const myQuestions = [{

    // Frage 1
    question: "Was tust du, wenn du in einer Klassenarbeit eine Aufgabe nicht lösen kannst?",
    answers: [{
        text: "Ich lasse die Aufgabe weg und hoffe, mit den anderen Aufgaben die fehlenden Punkte wettzumachen",
        points: 1
    },
        {
            text: "Ich gebe nicht auf, aber überspringe die Aufgabe erstmal und versuche später, die richtige Lösung zu finden",
            points: 3
        },
        {
            text: "Ich versuche es, aber wenn ich keine Lösung finde, ist das kein Weltuntergang",
            points: 2
        },
    ]
},
    {
        // Frage 2
        question: "Du planst mit deinen Freund*innen einen Ausflug. Ihr diskutiert eine Weile über das Ziel. Wie verhältst du dich?",
        answers: [{
            text: "Mein Ziel ist das Beste. Da lasse ich auch nicht mit mir reden.",
            points: 0
        },
            {
                text: "Ich versuche die anderen, mit guten Argumenten zu überzeugen, bin aber auch offen für die Meinung der anderen.",
                points: 3
            },
            {
                text: "Ich lasse die anderen entscheiden, damit es keinen Streit gibt.",
                points: 1
            },
        ]
    },
    {
        // Frage 3
        question: "Wo bist du nach der Schule am liebsten?",
        answers: [{
            text: "Ich bin beim Sport oder mit meinen Freunden unterwegs. Stillsitzen ist nichts für mich, das wird mir auf Dauer zu langweilig.",
            points: 2
        },
            {
                text: "Eigentlich bin ich am liebsten den ganzen Tag Zuhause, lese oder beschäftige mich am Computer.",
                points: 1
            },
            {
                text: "Ich bin gerne unterwegs, aber ich kann auch mal den ganzen Tag nur Zuhause sein.",
                points: 3
            },
        ]
    },
    {
        // Frage 4
        question: "Eine wichtige Entscheidung steht an. Was tust du?",
        answers: [{
            text: "Ich kann mich nicht entscheiden! Hilfe!",
            points: 0
        },
            {
                text: "Ich schaue mir die Vor- und Nachteile genau an und treffe dann eine gut überlegte Entscheidung.",
                points: 3
            },
            {
                text: "Ich lasse einfach mein Bauchgefühl entscheiden.",
                points: 2
            },
        ]
    },
    {
        // Frage 5
        question: "Deine beste Freundin fragt dich, ob du ihr heute nach der Schule bei den Hausaufgaben helfen kannst. Du hast aber ein wichtiges Training mit deinem Sportverein. Was sagst du deiner Freundin?",
        answers: [{
            text: "Natürlich helfe ich ihr! Das Training kann ich ja absagen, die kommen sicher auch ohne mich zurecht.",
            points: 0
        },
            {
                text: "Ich würde ihr wirklich gerne helfen, aber ich kann das Training nicht absagen. Meine Mannschaft zählt schließlich auf mich!",
                points: 2
            },
            {
                text: "Ich möchte weder meine Freundin hängen lassen, noch das Training ausfallen lassen. Ich rufe meine Freundin an, um uns für den Folgetag zu verabreden.",
                points: 3
            },
        ]
    },
    {
        // Frage 6
        question: "Nächste Woche hast du deine mündliche Prüfung in Englisch. Wie geht es dir?",
        answers: [{
            text: "Ich bin zuversichtlich. Natürlich bereite ich mich gut vor und übe vorher mit meinen Freunden.",
            points: 3
        },
            {
                text: "Hilfe, ich bin total nervös. Ich habe jetzt schon Bauchschmerzen, wenn ich daran denke.",
                points: 1
            },
            {
                text: "Ich mache mir gar keine Sorgen, ich schaff das mit links. Lernen muss ich eigentlich auch nicht.",
                points: 0
            },
        ]
    },
    {
        // Frage 7
        question: "Deine Schule veranstaltet ein Sommerfest und deine Klasse soll eine Losbude organisieren. Dein Klassenlehrer fragt, wer sich darum kümmern möchte.",
        answers: [{
            text: "Ich melde sofort. Ich bin ein Planungstalent und es macht mir total Spaß, so etwas zu organisieren.",
            points: 3
        },
            {
                text: "Eigentlich bin ich nicht gut im Planen, aber ich möchte trotzdem gerne mithelfen.",
                points: 2
            },
            {
                text: "Ich habe Angst, dabei etwas falsch zu machen, deshalb melde ich mich nicht.",
                points: 0
            },
        ]
    },
    {
        // Frage 8
        question: "Du hast dich mit deinem besten Freund gestritten. Was machst du?",
        answers: [{
            text: "Ich bin total sauer! Er hat schließlich angefangen. Ich entschuldige mich nur, wenn er sich zuerst entschuldigt.",
            points: 0
        },
            {
                text: "Eigentlich habe ich keine Schuld an dem Streit, aber ich entschuldige mich trotzdem. Ich kann es nicht ertragen, dass er sauer auf mich ist.",
                points: 1
            },
            {
                text: "Ich führe ein ruhiges und ehrliches Gespräch mit meinem Freund und sage ihm, wie ich mich fühle.",
                points: 3
            },
        ]
    },
    {
        // Frage 9
        question: "In der Schule sollt ihr eine Gruppenaufgabe machen. Wie findest du das?",
        answers: [{
            text: "Find ich super! Ich lehne mich entspannt zurück und warte, bis meine Teammitglieder fertig sind.",
            points: 0
        },
            {
                text: "Gruppenarbeiten machen mir Spaß, solange sich jeder an seine Aufgaben hält.",
                points: 3
            },
            {
                text: "Ich arbeite lieber für mich alleine.",
                points: 1
            },
        ]
    },
    {
        // Frage 10
        question: "Ein neuer Junge kommt in deine Klasse. Was tust du?",
        answers: [{
            text: "Ich spreche ihn sofort an und zeige ihm alles. Ich freue mich immer, neue Leute kennenzulernen.",
            points: 3
        },
            {
                text: "Ich bin ziemlich schüchtern und traue mich nicht, ihn anzusprechen, obwohl er echt nett wirkt.",
                points: 0
            },
            {
                text: "Ich habe schon genug Freunde, also bin ich ganz nett zu ihm, mehr aber auch nicht.",
                points: 0
            },
        ]
    },
    {
        // Frage 11
        question: "Dir fällt auf, dass eine Mitschülerin seit Tagen sehr schlecht gelaunt ist. Was tust du?",
        answers: [{
            text: "Jeder ist mal schlecht drauf, das geht wieder weg. Ich warte also ab, bis es ihr wieder besser geht.",
            points: 1
        },
            {
                text: "Ich warte auf einen Moment alleine mit ihr und frage sie vorsichtig, ob etwas nicht stimmt.",
                points: 3
            },
            {
                text: "Ich erzähle dem Klassenlehrer, was mir aufgefallen ist, damit er eine Lösung findet.",
                points: 1
            },
        ]
    },
    {
        // Frage 12
        question: "Deine Lehrerin ermahnt dich, weil deine Hausaufgaben nicht ordentlich sind. Was tust du?",
        answers: [{
            text: "Meine Lehrerin hat Recht. Ich nehme es mir zu Herzen und versuche beim nächsten Mal, die Hausaufgaben ordentlicher zu machen.",
            points: 3
        },
            {
                text: "Ich weiß zwar, dass meine Hausaufgaben nicht ordentlich sind, das ist mir aber egal. Beim nächsten Mal mache ich sie genauso. ",
                points: 0
            },
            {
                text: "Ich verstehe nicht, warum meine Ordentlichkeit kritisiert wird, deshalb frage ich meine Lehrerin, was ich besser machen kann und versuche es beim nächsten Mal umzusetzen. ",
                points: 3
            }
        ]
    },
    {
        // Frage 13
        question: "Jemand von deinen Mitschülern versteht eine Aufgabe nicht. Wie reagierst du?",
        answers: [{
            text: "Ich muss mich auf meine eigenen Aufgaben konzentrieren, um nicht hinterher zu hängen.",
            points: 1
        },
            {
                text: "Da es mir schwerfällt, jemandem etwas zu erklären, sage ich dem Lehrer Bescheid.",
                points: 0
            },
            {
                text: "Mir fällt es super leicht, anderen etwas zu erklären, also helfe ich gerne und lerne dadurch selber mehr.",
                points: 3
            },
        ]
    },
    {
        // Frage 14
        question: "Du musst eine Präsentation vor der Klasse halten. Wie verhältst du dich?",
        answers: [{
            text: "Ich bereite mich frühzeitig darauf vor, damit alles perfekt läuft und ich keine Fehler mache.",
            points: 3
        },
            {
                text: "Ich fühle mich sicher in dem, was ich weiß, und wenn mal ein Fehler passiert, ist das so.",
                points: 2
            },
            {
                text: "Ich habe mich zwar gut vorbereitet, aber ich bin sehr nervös. Es könnte ja etwas schief gehen…",
                points: 1
            },
        ]
    },
    {
        // Frage 15
        question: "Du sollst eine Freundin beim Shoppen beraten. Wie verhältst du dich ?",
        answers: [{
            text: "Ich gucke zwischendurch mal, was sie sich ausgesucht hat. Ansonsten schaue ich aber auch nach Kleidung für mich.",
            points: 2
        },
            {
                text: "Ich frage meine Freundin vorab, was sie gebrauchen kann und suche entsprechende Teile mit ihr raus.",
                points: 3
            },
            {
                text: "Ich schaue, was mir gut gefällt und schlage ihr die Kleidungsstücke dann vor.",
                points: 2
            },
        ]
    },
    {
        // Frage 16
        question: "Du hast seit Kurzem einen Nebenjob im Restaurant. Die Gäste sind fertig mit dem Essen und du bietest Nachtisch an, was die Gäste aber ablehnen. Wie gehst du vor?",
        answers: [{
            text: "Ich bedanke mich und wünsche einen schönen Abend.",
            points: 0
        },
            {
                text: "Ich bedanke mich und erkundige mich, ob es denn z.B. ein Espresso sein darf.",
                points: 2
            },
            {
                text: "Ich hake einmal nach und empfehle den Nachtisch der Woche, den ich selbst am Vortag probiert habe und der super lecker war.",
                points: 3
            },
        ]
    },
];

// Global
let executed = false;
let counter = 0;
let currentPoints = 0;
const length = myQuestions.length - 1;
// Global End

function startQuiz() {

    const container = jQuery('#quiz');
    const question = jQuery('#question');
    const a = jQuery('#label-a');
    const b = jQuery('#label-b');
    const c = jQuery('#label-c');
    const points = jQuery('#point-checker');
    let button = jQuery('.quiz-start');
    const header = jQuery('header');

    button.on('click', function () {

        button.animate({opacity: 0});
        setTimeout(function(){
            button.addClass('hidden')
        }, 1000);
        container.removeClass('hide');
        container.animate({opacity: 1});
        container.addClass('position-bottom');
        header.addClass('padding-bottom');
        jQuery('.contest-prices').addClass('position-bottom');

        question.append(myQuestions[0].question);
        a.append(myQuestions[0].answers[0].text);
        b.append(myQuestions[0].answers[1].text);
        c.append(myQuestions[0].answers[2].text);
        points.append('Punktestand: 0 Punkte');

    })
}

function next() {

    function isOneChecked() {
        let input = jQuery('.mandatory');

        for (let i=0; i< input.length; i++) {
            if (input.is(':checked') === true) {
                return true;
            }
        }
        return false;
    }

    function returnPoints() {
        if (jQuery('#a').is(':checked')) return myQuestions[counter].answers[0].points;
        if (jQuery('#b').is(':checked')) return myQuestions[counter].answers[1].points;
        if (jQuery('#c').is(':checked')) return myQuestions[counter].answers[2].points;
    }

    let button = jQuery('#next');

    button.on('click', function () {
        if (isOneChecked() === true) {
            if (counter <= length && executed === false) currentPoints += returnPoints();
            if (counter === length) {
                executed = true;
            }
            if (counter < length) counter++;
            let questionCounter = counter+1;
            let element = jQuery('#number-' + questionCounter );
            let previousElement = jQuery('#number-' + counter );
            previousElement.removeClass('current-question');
            element.addClass('current-question');
            updateQuiz();
            setTimeout(function(){
                jQuery('#a').prop('checked', false);
                jQuery('#b').prop('checked', false);
                jQuery('#c').prop('checked', false);
            },1);

            if (executed === true) {
                jQuery('.index').addClass('hide');
                button.addClass('hide');
                jQuery('#question').empty();
                jQuery('.quiz-top .heading h1').empty();
                jQuery('.answers').addClass('hide');
                jQuery('.quiz-top .heading h1').append('Dein Ergebnis');
                if (currentPoints >= 28) jQuery('#result-1').removeClass('hide');
                if (currentPoints < 28 && currentPoints > 9) jQuery('#result-2').removeClass('hide');
                if (currentPoints < 10) jQuery('#result-3').removeClass('hide');
                jQuery('.contest-prices').removeClass('hide');
            }
        }

        if (isOneChecked() === false) {
            alert("Bitte wähle eine der drei Antwortmöglichkeiten aus, damit du zur nächsten Frage kommst.");
        }
    })
}

function clearEverything() {
    const question = jQuery('#question');
    const a = jQuery('#label-a');
    const b = jQuery('#label-b');
    const c = jQuery('#label-c');
    const points = jQuery('#point-checker');


    question.empty();
    a.empty();
    b.empty();
    c.empty();
    points.empty();
}

function updateQuiz() {

    const question = jQuery('#question');
    const a = jQuery('#label-a');
    const b = jQuery('#label-b');
    const c = jQuery('#label-c');
    const points = jQuery('#point-checker');

    clearEverything();

    question.append(myQuestions[counter].question);
    a.append(myQuestions[counter].answers[0].text);
    b.append(myQuestions[counter].answers[1].text);
    c.append(myQuestions[counter].answers[2].text);
    points.append('Punktestand: ' + currentPoints + ' Punkte');
}

function responseOutput() {
    let button = jQuery('.wpcf7-form-control');
    let element = jQuery('.wpcf7-response-output');
    let checkbox = jQuery('input[name=dataprivacy]');

    button.on('click', function(){
        if(!checkbox.is(':checked')){
            element.clear();
            element.addClass('show');
            element.append('Ein oder mehrere Felder weisen einen Fehler auf. Bitte überprüfe das und versuche es erneut.');
        }
    })
}

function initOptOut()
{
    var opt_out_link = jQuery('#wpcn-optout-link, .wpcn-optout-link');
    var cookie_lifetime = parseInt(cookie_lifetime_var.expires);
    // CLICK Opt Out Link
    opt_out_link.on('click', function() {
        // Set Cookies
        var cookieDomain = window.location.hostname;
        cookieDomain = cookieDomain.split('.')
        var cookieDomain2 = cookieDomain.pop()
        var cookieDomain1 = cookieDomain.pop()
        cookieDomain = '.' + cookieDomain1 + '.' + cookieDomain2

        var theCookies = document.cookie.split(';');
        var aString = '';
        var bString = '';
        for (var i = 1 ; i <= theCookies.length; i++) {
            aString += ' ' + theCookies[i-1] + " ";
        }
        var term = '_gat_'; // search term (regex pattern)
        var search = new RegExp(term , 'i');
        bString = aString.split(' ');
        cString = bString.filter(item => search.test(item));
        dString = ""+cString+"";
        dString = dString.slice(0, -2);
        Cookies.remove('wpcn-show-cookie-notice');
        Cookies.remove('wpcn-cookie-notice');
        Cookies.remove('_ga', { path: '/', domain: cookieDomain })
        Cookies.remove('_gid', { path: '/', domain: cookieDomain })
        Cookies.remove(dString, { path: '/', domain: cookieDomain })

        window.location.reload();
    });
}

// Init BrowserCheck
function initBrowserCheck() {
    function isIE() {
        ua = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
        return is_ie;
    }

    /* Create an alert to show if the browser is IE or not */
    if ( isIE() ) {
        jQuery('.ie-check').show();
    }
}


